import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesPolitics = () => {
    const politicalViewNames = ['Liberal','Apolitical','Conservative','Other','Prefer Not to Say'];

    return (
        <div className="chip-container">
            <RadioChipContainer labels={politicalViewNames} type="politicalView" />
        </div>
    );
};

export default VirtuesPolitics;